import { requestGet as wsRequestGet, requestPost as wsRequestPost, requestDelete as wsRequestDelete } from './_wsApiFetchData';

export async function getProxies(language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/proxy', language, timeZone, null, cancelToken);
}

export async function getWebshareProxies(language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/proxy/webshare', language, timeZone, null, cancelToken);
}

export async function addProxy(data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/proxy/add', language, timeZone, data, null, cancelToken);
}

export async function updateProxy(proxyId, data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/proxy/update', language, timeZone, data, { proxyId }, cancelToken);
}

export async function deleteProxy(proxyId, language, timeZone, cancelToken) {
    return await wsRequestDelete('/admin/proxy', language, timeZone, null, { proxyId }, cancelToken);
}

export async function assignProxyToSystemType(proxyId, systemType, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/proxy/assign', language, timeZone, null, { proxyId, systemType }, cancelToken);
}

export async function replaceProxy(proxyId, dryRun, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/proxy/replace', language, timeZone, null, { proxyId, dryRun }, cancelToken);
}

export async function completeProxyReplacement(proxyId, planId, replacementId, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/proxy/replace/complete', language, timeZone, null, { proxyId, planId, replacementId }, cancelToken);
}
